import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { business } from '../data/business';
import { legalItems } from '../data/legal';
import { SiteFooter } from '../components/SiteFooter';
export function Terms() {
  return <div className="min-h-screen w-full bg-ivory-50 font-sans text-graphite-900" data-id="element-233" data-mp="2gwhgwdo07ur">
      <main className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-234" data-mp="7ar2q48x4uvy">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-emerald-700 hover:text-gold-600" data-id="element-235" data-mp="c7r5o6ah1hiu">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="l8xrmuvw3kjh" />
          Volver al inicio
        </Link>

        <h1 className="mt-8 font-display text-3xl font-semibold text-emerald-900 sm:text-4xl" data-id="element-237" data-mp="q78yqxusvgy0">
          Términos y Condiciones
        </h1>
        <p className="mt-4 text-sm text-graphite-700/80" data-id="element-238" data-mp="2n2oohjx8qoiv">
          {business.brand} — {business.legalName}
        </p>

        <div className="mt-10 space-y-10 text-sm leading-relaxed text-graphite-700" data-id="element-239" data-mp="239ctfwn829rw">
          <section data-id="element-240" data-mp="23b7h3ipvofzo">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-241" data-mp="1yiwf8abkuk4h">
              1. Naturaleza del servicio
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-242" data-mp="1tkcta9wzh8c4">
              {legalItems.map(item => <li key={item} className="border-l-2 border-gold-400/70 pl-4" data-id="element-243" data-mp="1pizkps2iar1i">
                  {item}
                </li>)}
            </ul>
          </section>

          <section data-id="element-244" data-mp="2h8maszn5z9xg">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-245" data-mp="2ha74yo5kgqus">
              2. Consultas y alcance
            </h2>
            <p className="mt-4" data-id="element-246" data-mp="2d9n8lmsthr9p">
              Cada consulta es personalizada y se aborda según las
              circunstancias, necesidades y creencias de cada persona. La
              experiencia y los resultados pueden variar de una persona a otra
              y no se garantizan resultados específicos.
            </p>
          </section>

          <section data-id="element-247" data-mp="y9y0xsn8q18j">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-248" data-mp="ybrbvk4vz7mc">
              3. Costos y condiciones de pago
            </h2>
            <p className="mt-4" data-id="element-249" data-mp="1376n04biepf2">{business.costsNote}</p>
            <p className="mt-4" data-id="element-250" data-mp="p8zw584z9pow">
              [Completar con el detalle de precios, materiales, métodos de pago
              y condiciones aplicables según la información real del negocio.]
            </p>
          </section>

          <section data-id="element-251" data-mp="fhvhyan4m8v4">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-252" data-mp="kaop1562htad">
              4. Política de devoluciones
            </h2>
            <p className="mt-4" data-id="element-253" data-mp="5mtstesup6sj">
              [Completar con la política de devoluciones real: plazo para
              solicitar una devolución, servicios o materiales que aplican,
              procedimiento de solicitud y forma de reembolso.]
            </p>
          </section>

          <section data-id="element-254" data-mp="1kp5exszx6ec">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-255" data-mp="1ivuh6bco00j">
              5. Contacto
            </h2>
            <p className="mt-4" data-id="element-256" data-mp="3e41jpca3g0xa">
              Llamadas: {business.phone} · WhatsApp: {business.whatsapp} ·
              Dirección: {business.address}
            </p>
          </section>
        </div>
      </main>
      <SiteFooter data-id="element-257" data-mp="3n2dabeaymypq" />
    </div>;
}